// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deposit_next_wrap {
  margin-top: 24px;
  max-width: 260px;
}

#deposit_proof.deposit_proof_modal .modal-dialog {
  max-width: 440px;
}

#deposit_proof.deposit_proof_modal .modal-content {
  background: #111214;
  border: 1px solid #2a2a2a;
  border-radius: 18px;
  overflow: hidden;
  max-height: 90vh;
}

#deposit_proof.deposit_proof_modal .modal-header {
  align-items: flex-start;
  padding: 18px 20px 0 !important;
  border-bottom: none !important;
}

#deposit_proof.deposit_proof_modal .modal-body {
  padding: 14px 20px 18px !important;
}

#deposit_proof.deposit_proof_modal .btn-close {
  filter: invert(1);
  opacity: 0.7;
  margin: 4px 0 0 auto;
}

.deposit_proof_head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-right: 12px;
}

.deposit_proof_head h2 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  line-height: 1.25;
}

.deposit_proof_head p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #9b9b9b;
}

.deposit_proof_chips {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
}

.deposit_proof_chip {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 8px 10px;
  background: #161616;
  border: 1px solid #2e2e2e;
  border-radius: 12px;
}

.deposit_proof_chip_icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #1f1f1f;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  color: #cfcfcf;
}

.deposit_proof_chip_icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.deposit_proof_chip small {
  display: block;
  font-size: 11px;
  color: #8d8d8d;
  line-height: 1.2;
}

.deposit_proof_chip strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deposit_proof_address {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding: 7px 10px;
  background: #161616;
  border: 1px solid #2e2e2e;
  border-radius: 10px;
}

.deposit_proof_address span {
  font-size: 11px;
  color: #8d8d8d;
  flex-shrink: 0;
}

.deposit_proof_address p {
  margin: 0;
  font-size: 12px;
  color: #e8e8e8;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  word-break: break-all;
  text-align: right;
  flex: 1 1;
}

.deposit_proof_copy {
  border: none;
  background: transparent;
  color: #9b9b9b;
  padding: 0;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}

.deposit_proof_copy:hover {
  color: #fff;
}

.deposit_proof_limit {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: #8d8d8d;
}

.deposit_proof_field {
  margin-bottom: 12px;
}

.deposit_proof_field > label {
  display: block;
  margin-bottom: 7px;
  font-size: 12px;
  font-weight: 600;
  color: #cfcfcf;
}

.deposit_proof_input_wrap {
  position: relative;
}

#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input {
  width: 100%;
  height: 44px;
  padding: 11px 14px !important;
  background: #161616;
  border: 1px solid #2e2e2e !important;
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  outline: none;
  box-shadow: none;
}

#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input.has-icon {
  padding-left: 40px !important;
}

#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input:focus {
  border-color: #2563eb !important;
}

#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input::placeholder {
  color: #6f6f6f;
}

.deposit_proof_suffix {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 700;
  color: #9b9b9b;
  pointer-events: none;
}

#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input[type="number"] {
  padding-right: 72px !important;
  appearance: textfield;
  -moz-appearance: textfield;
}

#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input[type="number"]::-webkit-outer-spin-button,
#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.deposit_proof_input_icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #7a7a7a;
  font-size: 16px;
  pointer-events: none;
}

.deposit_proof_upload {
  position: relative;
}

.deposit_proof_upload input[type="file"] {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0 !important;
  cursor: pointer;
  z-index: 2;
  padding: 0 !important;
  border: none !important;
  background: transparent;
}

.deposit_proof_upload_empty,
.deposit_proof_upload_filled {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  cursor: pointer;
  border: 1px dashed #3a3a3a;
  border-radius: 12px;
  background: #141414;
}

.deposit_proof_upload_empty {
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-height: 86px;
  padding: 14px 12px;
  text-align: center;
}

.deposit_proof_upload_empty i {
  font-size: 26px;
  color: #5b8def;
  margin-bottom: 4px;
}

.deposit_proof_upload_empty strong,
.deposit_proof_upload_filled strong {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

.deposit_proof_upload_empty span,
.deposit_proof_upload_filled span {
  font-size: 12px;
  color: #8d8d8d;
}

.deposit_proof_upload_filled {
  gap: 12px;
  min-height: 76px;
  padding: 10px 12px;
  border-style: solid;
  border-color: #2e2e2e;
}

.deposit_proof_upload_filled img {
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 8px;
  background: #1f1f1f;
  flex-shrink: 0;
}

.deposit_proof_upload_copy {
  min-width: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.deposit_proof_upload_copy span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deposit_proof_upload_filled em {
  font-style: normal;
  font-size: 12px;
  font-weight: 600;
  color: #5b8def;
  flex-shrink: 0;
}

.deposit_proof_submit {
  width: 100%;
  margin-top: 6px;
  padding: 13px 16px;
  border: none;
  border-radius: 50px;
  background: #2563eb;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.deposit_proof_submit:hover:not(:disabled) {
  opacity: 0.92;
}

.deposit_proof_submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.deposit_proof_note {
  margin: 10px 0 0;
  text-align: center;
  font-size: 12px;
  line-height: 1.45;
  color: #7a7a7a;
}

.recent_deposit_list .top_heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.deposit_status_filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.deposit_status_filter {
  border: 1px solid #2e2e2e;
  background: #161616;
  color: #c1c1c1;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.deposit_status_filter.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.recent_deposit_list .deposit_status_badge {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 20px;
  line-height: 1.3;
}

.recent_deposit_list .deposit_status_badge.pending {
  color: #f6cf25 !important;
  background: rgba(246, 207, 37, 0.14);
}

.recent_deposit_list .deposit_status_badge.completed {
  color: #5ec732 !important;
  background: rgba(94, 199, 50, 0.14);
}

.recent_deposit_list .deposit_status_badge.rejected {
  color: #f52534 !important;
  background: rgba(245, 37, 52, 0.14);
}

.search_form .deposit_status_badge {
  display: inline-flex;
  font-weight: 600;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 20px;
}

.search_form .deposit_status_badge.pending {
  color: #f6cf25;
  background: rgba(246, 207, 37, 0.14);
}

.search_form .deposit_status_badge.completed {
  color: #5ec732;
  background: rgba(94, 199, 50, 0.14);
}

.search_form .deposit_status_badge.rejected {
  color: #f52534;
  background: rgba(245, 37, 52, 0.14);
}

.deposit_reject_reason {
  display: block;
  max-width: 180px;
  margin-top: 4px;
  font-size: 11px;
  color: #f52534;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent_deposit_list .deposit_status_col {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.deposit_status_row {
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 575px) {
  #deposit_proof.deposit_proof_modal .modal-dialog {
    margin: 16px;
  }

  .deposit_proof_chips {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/DepositPage/deposit.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,6EAA6E;EAC7E,qBAAqB;EACrB,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".deposit_next_wrap {\n  margin-top: 24px;\n  max-width: 260px;\n}\n\n#deposit_proof.deposit_proof_modal .modal-dialog {\n  max-width: 440px;\n}\n\n#deposit_proof.deposit_proof_modal .modal-content {\n  background: #111214;\n  border: 1px solid #2a2a2a;\n  border-radius: 18px;\n  overflow: hidden;\n  max-height: 90vh;\n}\n\n#deposit_proof.deposit_proof_modal .modal-header {\n  align-items: flex-start;\n  padding: 18px 20px 0 !important;\n  border-bottom: none !important;\n}\n\n#deposit_proof.deposit_proof_modal .modal-body {\n  padding: 14px 20px 18px !important;\n}\n\n#deposit_proof.deposit_proof_modal .btn-close {\n  filter: invert(1);\n  opacity: 0.7;\n  margin: 4px 0 0 auto;\n}\n\n.deposit_proof_head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding-right: 12px;\n}\n\n.deposit_proof_head h2 {\n  margin: 0 0 4px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.25;\n}\n\n.deposit_proof_head p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #9b9b9b;\n}\n\n.deposit_proof_chips {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.deposit_proof_chip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 8px 10px;\n  background: #161616;\n  border: 1px solid #2e2e2e;\n  border-radius: 12px;\n}\n\n.deposit_proof_chip_icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #1f1f1f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n  color: #cfcfcf;\n}\n\n.deposit_proof_chip_icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.deposit_proof_chip small {\n  display: block;\n  font-size: 11px;\n  color: #8d8d8d;\n  line-height: 1.2;\n}\n\n.deposit_proof_chip strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.deposit_proof_address {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n  padding: 7px 10px;\n  background: #161616;\n  border: 1px solid #2e2e2e;\n  border-radius: 10px;\n}\n\n.deposit_proof_address span {\n  font-size: 11px;\n  color: #8d8d8d;\n  flex-shrink: 0;\n}\n\n.deposit_proof_address p {\n  margin: 0;\n  font-size: 12px;\n  color: #e8e8e8;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  word-break: break-all;\n  text-align: right;\n  flex: 1;\n}\n\n.deposit_proof_copy {\n  border: none;\n  background: transparent;\n  color: #9b9b9b;\n  padding: 0;\n  line-height: 1;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.deposit_proof_copy:hover {\n  color: #fff;\n}\n\n.deposit_proof_limit {\n  display: block;\n  margin-top: 6px;\n  font-size: 11px;\n  color: #8d8d8d;\n}\n\n.deposit_proof_field {\n  margin-bottom: 12px;\n}\n\n.deposit_proof_field > label {\n  display: block;\n  margin-bottom: 7px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #cfcfcf;\n}\n\n.deposit_proof_input_wrap {\n  position: relative;\n}\n\n#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input {\n  width: 100%;\n  height: 44px;\n  padding: 11px 14px !important;\n  background: #161616;\n  border: 1px solid #2e2e2e !important;\n  border-radius: 12px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  box-shadow: none;\n}\n\n#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input.has-icon {\n  padding-left: 40px !important;\n}\n\n#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input:focus {\n  border-color: #2563eb !important;\n}\n\n#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input::placeholder {\n  color: #6f6f6f;\n}\n\n.deposit_proof_suffix {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  font-weight: 700;\n  color: #9b9b9b;\n  pointer-events: none;\n}\n\n#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input[type=\"number\"] {\n  padding-right: 72px !important;\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input[type=\"number\"]::-webkit-outer-spin-button,\n#deposit_proof.deposit_proof_modal .deposit_proof_input_wrap input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.deposit_proof_input_icon {\n  position: absolute;\n  left: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #7a7a7a;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n.deposit_proof_upload {\n  position: relative;\n}\n\n.deposit_proof_upload input[type=\"file\"] {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0 !important;\n  cursor: pointer;\n  z-index: 2;\n  padding: 0 !important;\n  border: none !important;\n  background: transparent;\n}\n\n.deposit_proof_upload_empty,\n.deposit_proof_upload_filled {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0;\n  cursor: pointer;\n  border: 1px dashed #3a3a3a;\n  border-radius: 12px;\n  background: #141414;\n}\n\n.deposit_proof_upload_empty {\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n  min-height: 86px;\n  padding: 14px 12px;\n  text-align: center;\n}\n\n.deposit_proof_upload_empty i {\n  font-size: 26px;\n  color: #5b8def;\n  margin-bottom: 4px;\n}\n\n.deposit_proof_upload_empty strong,\n.deposit_proof_upload_filled strong {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.deposit_proof_upload_empty span,\n.deposit_proof_upload_filled span {\n  font-size: 12px;\n  color: #8d8d8d;\n}\n\n.deposit_proof_upload_filled {\n  gap: 12px;\n  min-height: 76px;\n  padding: 10px 12px;\n  border-style: solid;\n  border-color: #2e2e2e;\n}\n\n.deposit_proof_upload_filled img {\n  width: 52px;\n  height: 52px;\n  object-fit: cover;\n  border-radius: 8px;\n  background: #1f1f1f;\n  flex-shrink: 0;\n}\n\n.deposit_proof_upload_copy {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.deposit_proof_upload_copy span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.deposit_proof_upload_filled em {\n  font-style: normal;\n  font-size: 12px;\n  font-weight: 600;\n  color: #5b8def;\n  flex-shrink: 0;\n}\n\n.deposit_proof_submit {\n  width: 100%;\n  margin-top: 6px;\n  padding: 13px 16px;\n  border: none;\n  border-radius: 50px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.deposit_proof_submit:hover:not(:disabled) {\n  opacity: 0.92;\n}\n\n.deposit_proof_submit:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.deposit_proof_note {\n  margin: 10px 0 0;\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #7a7a7a;\n}\n\n.recent_deposit_list .top_heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.deposit_status_filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.deposit_status_filter {\n  border: 1px solid #2e2e2e;\n  background: #161616;\n  color: #c1c1c1;\n  border-radius: 20px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.deposit_status_filter.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.recent_deposit_list .deposit_status_badge {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 3px 8px;\n  border-radius: 20px;\n  line-height: 1.3;\n}\n\n.recent_deposit_list .deposit_status_badge.pending {\n  color: #f6cf25 !important;\n  background: rgba(246, 207, 37, 0.14);\n}\n\n.recent_deposit_list .deposit_status_badge.completed {\n  color: #5ec732 !important;\n  background: rgba(94, 199, 50, 0.14);\n}\n\n.recent_deposit_list .deposit_status_badge.rejected {\n  color: #f52534 !important;\n  background: rgba(245, 37, 52, 0.14);\n}\n\n.search_form .deposit_status_badge {\n  display: inline-flex;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 3px 8px;\n  border-radius: 20px;\n}\n\n.search_form .deposit_status_badge.pending {\n  color: #f6cf25;\n  background: rgba(246, 207, 37, 0.14);\n}\n\n.search_form .deposit_status_badge.completed {\n  color: #5ec732;\n  background: rgba(94, 199, 50, 0.14);\n}\n\n.search_form .deposit_status_badge.rejected {\n  color: #f52534;\n  background: rgba(245, 37, 52, 0.14);\n}\n\n.deposit_reject_reason {\n  display: block;\n  max-width: 180px;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #f52534;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.recent_deposit_list .deposit_status_col {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.deposit_status_row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n@media (max-width: 575px) {\n  #deposit_proof.deposit_proof_modal .modal-dialog {\n    margin: 16px;\n  }\n\n  .deposit_proof_chips {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
